import Vue from 'vue';
import ViewModelBase from '../../core/v2/app/viewModelBase';
import { GoogleMapsApi } from '../../plugins/map/mapProvider/googleMapsProvider';

export default class PLocationViewModel extends ViewModelBase {
  get apiKey() { return Vue.$config.values['google-mapsapikey']; }

  get googleMapsVersion() { return Vue.$config.values['google-mapsversion']; }

  get googleMapsMapId() { return Vue.$config.values['google-mapsmapid']; }

  mapApi?: GoogleMapsApi;

  map?: google.maps.Map = undefined;

  marker?: google.maps.marker.AdvancedMarkerElement = undefined;

  mapHtmlElement = {} as HTMLElement;

  searchHtmlInputElement = {} as HTMLInputElement;

  searchBox = undefined as any;

  longitude = 0 as number;

  latitude = 0 as number;

  zoom = 0 as number;

  setMarker = true as boolean;

  isInEditMode = false as boolean;

  previousLatitude = 0 as number;

  previousLongitude = 0 as number;

  async initialize(): Promise<void> {
    await this.initializeMap();
  }

  async initializeMap() {
    this.mapApi = await Vue.$map.google.initialize('core', 'marker', 'maps', 'places');
    this.map = new this.mapApi!.maps.Map(this.mapHtmlElement, {
      center: { lat: this.latitude, lng: this.longitude },
      mapTypeId: this.mapApi!.maps.MapTypeId.SATELLITE,
      disableDefaultUI: true,
      zoom: this.zoom,
      mapId: this.googleMapsMapId,
    });

    const self = this; // Cause of arrow func shenanigans
    this.mapApi!.core.event.addListener(this.map, 'click', (event: any) => {
      if (self.isInEditMode) {
        self.drawMarker(event.latLng.lat(), event.latLng.lng());
      }
    });

    if (this.setMarker) {
      this.drawMarker(this.latitude, this.longitude);
    }
  }

  drawMarker(lat: number, lng: number) {
    const latLng = new this.mapApi!.core.LatLng(lat, lng);

    if (this.marker === undefined) {
      this.marker = new this.mapApi!.marker.AdvancedMarkerElement({
        position: latLng,
        map: this.map,
      });
    } else {
      this.marker.position = latLng;
    }

    this.latitude = lat;
    this.longitude = lng;
  }

  populateMap() {
    if (!Number(this.latitude) || !Number(this.longitude)) {
      return;
    }
    const panPoint = new this.mapApi!.core.LatLng(this.latitude, this.longitude);
    this.map?.panTo(panPoint);
    this.drawMarker(this.latitude, this.longitude);
  }

  centerMap() {
    if (!Number(this.latitude) || !Number(this.longitude)) {
      return;
    }
    const panPoint = new this.mapApi!.core.LatLng(this.latitude, this.longitude);
    this.map?.panTo(panPoint);
  }

  setViewMode() {
    this.isInEditMode = false;
    this.map?.setOptions({ disableDefaultUI: true });
  }

  onCancel() {
    this.latitude = this.previousLatitude;
    this.longitude = this.previousLongitude;
    this.populateMap();
    this.setViewMode();
  }

  clearSearch() {
    this.mapApi?.core.event.clearListeners(this.searchBox, 'places_changed');
  }
}
